/**
 * SiteRererrer(OTA)関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */

import { Record } from 'immutable'
import OptionState from './OptionState'

class SiteReferrerOptionState extends Record(OptionState) {
  mergeModel(model) {
    return this.merge({
      label: model.name,
      value: model.id
    })
  }
  mergeNameModel(model) {
    return this.merge({
      label: model.name,
      value: model.name
    })
  }
}

export default SiteReferrerOptionState
